import type { SVGProps } from "react";
import * as React from "react";

const SvgEdit2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 3a2.827 2.827 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z"
    />
  </svg>
);
export default SvgEdit2;
